import React from "react"; 
import SignUpForm from "../../components/Authentication/SignUpForm";

const SignUp = () => {
  return (
    <>
      <SignUpForm />
    </>
  );
};

export default SignUp;
